import React, { useState } from "react";
import { Link } from "react-router-dom";
import AppButton from "../../components/AppButton";
import Dropdown from "../../components/Dropdown";
import ProgressBar from "../../components/ProgressBar";
import TextInput from "../../components/TextInput";
import { Formik } from "formik";
import { useHistory } from "react-router-dom";

import "./auth.styles.css";
import Auth from "@aws-amplify/auth";
import { SignupSchema } from "./ValidationSchema";

const RegisterPage = () => {
  const [step, setStep] = useState(1);

  const nextStep = () => {
    setStep(2);
  };

  return (
    <div className="auth__wrapper">
      <div className="auth__wrapper--left">
        <p>
          The standard Lorem Ipsum passage, used since the 1500s "Lorem ipsum
          dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
          incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
          quis nostrud exercitation ullamco laboris num."
        </p>
        <span>Dave, Product manager.</span>
        <span className="staricon">
          <svg
            width="326"
            height="390"
            viewBox="0 0 326 390"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M186.372 36.3389C190.287 32.3472 193.947 28.1124 197.33 23.6595L196.011 43.322C190.535 124.956 225.007 204.546 288.459 256.777L323.227 285.396C221.606 267.515 122.842 326.997 91.6221 425.209L74.8061 478.108C59.1196 370.143 -30.1724 287.228 -139.004 279.951L-149.149 279.273C-55.7233 246.855 -2.70966 148.251 -27.119 51.4925L-39.4814 2.48749L-4.27459 37.1287C49.085 89.6308 134.44 89.2836 186.372 36.3389Z"
              stroke="#FBFBFB"
            />
          </svg>
        </span>
      </div>
      <div className="auth__wrapper--right w--full">
        <div className="auth__wrapper--rightHeader">
          <ProgressBar step={step} />
        </div>
        <div className="auth__wrapper--rightMain">
          {step === 1 ? <StepOne nextStep={nextStep} /> : <StepTwo />}
        </div>
      </div>
    </div>
  );
};

const StepOne = ({ nextStep }) => {
  const [confirmedUser, setConfirmedUser] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [showConfirmationCodeError, setShowConfirmationCodeError] = useState(
    false
  );

  const [
    confirmationCodeErrorMessage,
    setConfirmationCodeErrorMessage,
  ] = useState("");

  async function signUpUser({ firstName, lastName, email, password }) {
    setIsLoading(true);

    try {
      const user = await Auth.signUp({
        username: email,
        password,
        attributes: { family_name: lastName, name: firstName },
      });

      setIsLoading(false);

      return user;
    } catch (error) {
      console.log("There was an error signing up the user", error);
    }
  }

  async function confirmSignedUpUser({ email, confirmationCode }) {
    setIsLoading(true);

    try {
      const response = await Auth.confirmSignUp(email, confirmationCode);

      setIsLoading(false);

      return response;
    } catch (error) {
      setConfirmationCodeErrorMessage(
        "Incorrect verification code, resend code"
      );

      setShowConfirmationCodeError(true);

      console.log(
        "There was an error confirming the signing up of the user",
        error
      );
    }
  }

  return (
    <>
      <p className="already-have-account-link">
        Already have an account? <Link to="/login">Log in</Link>
      </p>
      <h1 className="font--38">Create your account</h1>
      <Formik
        validationSchema={SignupSchema}
        validateOnChange={false}
        validateOnBlur={false}
        initialValues={{
          email: "",
          password: "",
          firstName: "",
          lastName: "",
          confirmationCode: "",
        }}
        onSubmit={async (values) => {
          const unconfirmedUser = await signUpUser({ ...values });

          if (unconfirmedUser) {
            setConfirmedUser(true);
          }
        }}
      >
        {({
          values,
          handleSubmit,
          handleChange,
          handleBlur,
          errors,
          touched,
        }) => (
          <form onSubmit={handleSubmit}>
            <div className="d-flex mt--16">
              <div className="flex--1">
                <TextInput
                  name="firstName"
                  value={values.firstName}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  label="First name"
                  type="text"
                  placeholder="John"
                  withError={errors.firstName && touched.firstName}
                  errorMessage={
                    errors.firstName &&
                    touched.firstName &&
                    "Please enter your first name"
                  }
                />
              </div>
              <div className="flex--1 gap--16">
                <TextInput
                  name="lastName"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.lastName}
                  label="Last name"
                  type="text"
                  placeholder="Smith"
                  withError={errors.lastName && touched.lastName}
                  errorMessage={
                    errors.lastName &&
                    touched.lastName &&
                    "Please enter your last name"
                  }
                />
              </div>
            </div>

            <div className="w--full mt--16">
              <TextInput
                label="Email address"
                placeholder="johnsmith@gmail.com"
                type="email"
                name="email"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.email}
                withError={errors.email && touched.email}
                errorMessage={
                  errors.email &&
                  touched.email &&
                  "Please enter your email address"
                }
              />
            </div>
            <div className="w--full mt--16">
              <TextInput
                label="Password"
                placeholder="*************"
                type="password"
                name="password"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.password}
                withError={errors.email && touched.email}
                errorMessage={
                  errors.email &&
                  touched.email &&
                  "Create a strong password, add an uppercase letter and a number."
                }
              />
            </div>

            {confirmedUser ? (
              <div className="mt-4">
                <p>
                  A confirmation code has been sent to your email address,
                  please enter the code to proceed.
                </p>
                <div>
                  <TextInput
                    name="confirmationCode"
                    type="text"
                    value={values.confirmationCode}
                    label="Enter confirmation code"
                    placeholder="Enter code"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    withError={showConfirmationCodeError}
                    errorMessage={confirmationCodeErrorMessage}
                  />
                </div>
              </div>
            ) : null}

            <div className="w--full">
              {!confirmedUser ? (
                <AppButton
                  title={"Create account"}
                  styles={{ width: "100%", marginTop: 16 }}
                  type="submit"
                  isLoading={isLoading}
                />
              ) : (
                <AppButton
                  title={"Verify account"}
                  styles={{ width: "100%", marginTop: 16 }}
                  type={"button"}
                  isLoading={isLoading}
                  onClick={async () => {
                    const response = await confirmSignedUpUser({
                      email: values.email,
                      confirmationCode: values.confirmationCode,
                    });

                    if (response === "SUCCESS") {
                      nextStep();
                    }
                  }}
                />
              )}
            </div>
          </form>
        )}
      </Formik>
    </>
  );
};

const StepTwo = () => {
  const history = useHistory();
  return (
    <>
      <h1 className="font--38">Welcome to klen</h1>
      <span className="form--subtitle">
        A little icebreaker to get us up and running
      </span>
      <div className="w--full mt--16">
        <Dropdown
          dropdown_title="Select your role"
          label="I primarily identify as"
          placeholder="Job role"
        />
      </div>
      <div className="w--full mt--16">
        <Dropdown
          dropdown_title="Select your role"
          placeholder="Please choose an option"
          label="What topic would you like to create content for?"
        />
      </div>

      <div className="w--full mt--16">
        <AppButton
          title="Get access now"
          styles={{ width: "100%", marginTop: 16 }}
          onClick={() => {
            history.push("/course");
          }}
        />
      </div>
    </>
  );
};

export default RegisterPage;
